import React from "react";

export default function FiltersSection({
  dropdownRef,
  userSearchTerm,
  setUserSearchTerm,
  isDropdownOpen,
  setIsDropdownOpen,
  filteredUsers,
  handleUserSelect,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  resetFilters,
  createdById,
  setCreatedById,
  createdByList,
}) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-3 border border-gray-200">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-5 h-5 bg-gray-400 rounded-sm flex items-center justify-center">
          <div className="w-3 h-3 border-2 border-white rounded-sm"></div>
        </div>
        <h2 className="text-lg font-semibold text-gray-800">Filters</h2>
        <button
          onClick={resetFilters}
          className="ml-auto flex items-center gap-1 text-sm text-indigo-600 hover:text-indigo-800 transition-colors px-3 py-1 rounded-md hover:bg-indigo-50"
        >
          <div className="w-4 h-4 border-2 border-current rounded-full relative">
            <div className="absolute top-0 right-0 w-2 h-2 border-l-2 border-b-2 border-current transform rotate-45 -translate-y-1"></div>
          </div>
          Reset
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* User Search Dropdown */}
        <div className="relative" ref={dropdownRef}>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <span className="inline-flex items-center gap-1">
              <div className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>
              Search User
            </span>
          </label>
          <div className="relative">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400">
              <svg fill="currentColor" viewBox="0 0 20 20" className="w-4 h-4">
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <input
              type="text"
              value={userSearchTerm}
              onChange={(e) => {
                setUserSearchTerm(e.target.value);
                setIsDropdownOpen(true);
              }}
              onFocus={() => setIsDropdownOpen(true)}
              placeholder="Search by name..."
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
            />
          </div>

          {isDropdownOpen && (
            <div className="absolute z-20 mt-2 w-full bg-white shadow-xl max-h-60 rounded-lg border border-gray-200 overflow-auto">
              <div className="py-2">
                <div
                  className="px-4 py-2 hover:bg-indigo-50 cursor-pointer transition-colors"
                  onClick={() => handleUserSelect("all", "All Users")}
                >
                  <span className="font-medium text-indigo-600">All Users</span>
                </div>
                {filteredUsers.length > 0 ? (
                  filteredUsers.map((user) => (
                    <div
                      key={user.ID}
                      className="px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors"
                      onClick={() => handleUserSelect(user.ID, user.pName)}
                    >
                      {user.pName}
                    </div>
                  ))
                ) : (
                  <div className="px-4 py-2 text-gray-500 italic">
                    No users found
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Created By ID Dropdown */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <span className="inline-flex items-center gap-1">
              <div className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>
              Filter by Created By
            </span>
          </label>
          <select
            value={createdById}
            onChange={(e) => setCreatedById(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
          >
            <option value="all">All</option>
            {createdByList.map((user) => (
              <option key={user.ID} value={user.ID}>
                {user.pName}
              </option>
            ))}
          </select>
        </div>

        {/* Start Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <span className="inline-flex items-center gap-1">
              <div className="w-4 h-4 border-2 border-gray-400 rounded-sm flex items-center justify-center">
                <div className="w-2 h-1 bg-gray-400"></div>
              </div>
              Start Date
            </span>
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
          />
        </div>

        {/* End Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <span className="inline-flex items-center gap-1">
              <div className="w-4 h-4 border-2 border-gray-400 rounded-sm flex items-center justify-center">
                <div className="w-2 h-1 bg-gray-400"></div>
              </div>
              End Date
            </span>
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
          />
        </div>
      </div>
    </div>
  );
}
